import App from "../../externalComponent/App";

export function Scheduler() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <App />
    </div>
  );
}
